var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerificationFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5216 32.2933L23.0395 4.16937C22.4124 3.09133 21.2474 2.42188 20 2.42188C18.7526 2.42188 17.5876 3.09133 16.9627 4.16828L0.478359 32.2933C0.164766 32.83 0 33.4411 0 34.0625C0 36.0011 1.57703 37.5781 3.51562 37.5781H36.4844C38.423 37.5781 40 36.0011 40 34.0625C40 33.4411 39.8352 32.83 39.5216 32.2933ZM20 30.5469C19.3528 30.5469 18.8281 30.0222 18.8281 29.375C18.8281 28.7277 19.3528 28.2031 20 28.2031C20.6472 28.2031 21.1719 28.7277 21.1719 29.375C21.1719 30.0222 20.6472 30.5469 20 30.5469ZM21.1719 24.6875C21.1719 25.3352 20.6477 25.8594 20 25.8594C19.3523 25.8594 18.8281 25.3352 18.8281 24.6875V12.9688C18.8281 12.321 19.3523 11.7969 20 11.7969C20.6477 11.7969 21.1719 12.321 21.1719 12.9688V24.6875Z",
    fill: "#ED2E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationFailed);
export default __webpack_public_path__ + "static/media/verificationFailed.968aa846.svg";
export { ForwardRef as ReactComponent };